var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_bell",
    "data-name": "Path / bell",
    d: "M19,17.381v.9H3v-.9l1.778-1.81V10.143A6.311,6.311,0,0,1,9.222,4.072V3.81a1.778,1.778,0,1,1,3.556,0v.262a6.311,6.311,0,0,1,4.444,6.071v5.429L19,17.381m-6.222,1.81a1.778,1.778,0,1,1-3.556,0",
    transform: "translate(-3 -2)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.4298d3ae3fad859b7ae6ef2693cf4125.svg";
export { ForwardRef as ReactComponent };